module.exports = __webpack_public_path__ + "img/product-fill.fd03c0fb.svg";